export type QueryParams = {
  [_name in string]?: string;
};

/**
 * Separates the query string from the path. Returns the path and the query string as an array. The first element is the path, the second element is the query string.
 */
export const separateQueryStringFromPath = (
  pathWithQueryString: string,
): [string, QueryParams] => {
  // Split the path and the query string
  const [path, queryString] = pathWithQueryString.split('?');

  // If there is no query string, return the path and an empty query object
  if (!queryString) {
    return [path, {}];
  }

  // Split the query string into key-value pairs & decode the query string values
  const query: QueryParams = {};

  queryString.split('&').forEach(keyWithValue => {
    const [key, value] = keyWithValue.split('=');

    query[key] = decodeURIComponent(value);
  });

  // Return the path and the query object
  return [path, query];
};
